"use strict";

const wishlist_items = JSON.parse(localStorage.getItem('bls__wishlist-items'));
const wishlistDiv = document.querySelector('.bls__wishlist-page-main');

// GA4 Helper
function trackWishlistEvent(eventName, productHandle, extraParams = {}) {
    if (typeof gtag === 'function') {
        gtag('event', eventName, {
            item_id: productHandle,
            item_list_name: 'Wishlist',
            ...extraParams
        });
    } else if (typeof dataLayer !== 'undefined') {
        dataLayer.push({
            event: eventName,
            item_id: productHandle,
            item_list_name: 'Wishlist',
            ...extraParams
        });
    }
}

// Track when wishlist page is viewed with items
function trackWishlistView(items) {
    if (typeof gtag === 'function') {
        gtag('event', 'view_wishlist', {
            item_list_name: 'Wishlist',
            items: items.map(handle => ({ item_id: handle })),
            wishlist_count: items.length
        });
    } else if (typeof dataLayer !== 'undefined') {
        dataLayer.push({
            event: 'view_wishlist',
            item_list_name: 'Wishlist',
            items: items.map(handle => ({ item_id: handle })),
            wishlist_count: items.length
        });
    }
}

var BlsWishlistPageShopify = (function() {
    return {

        initWishlistItems: function() {
            if (window.location.search.indexOf("page=") == -1) {
                this.init();
            }

            // 🔥 Listen for add-to-wishlist events fired elsewhere in the theme
            document.addEventListener('wishlist:add', function(e) {
                const handle = e.detail?.productHandle || e.detail?.handle;
                const productData = e.detail || {};
                trackWishlistEvent('add_to_wishlist', handle, {
                    item_name: productData.productTitle || '',
                    price: productData.price || '',
                    currency: window.Shopify?.currency?.active || 'USD'
                });
            });

            // 🔥 Listen for remove-from-wishlist events
            document.addEventListener('wishlist:remove', function(e) {
                const handle = e.detail?.productHandle || e.detail?.handle;
                trackWishlistEvent('remove_from_wishlist', handle);
            });
        },

        init: function () {
            const _this = this;
            if (wishlistDiv) {
                const div_no_product = wishlistDiv.querySelector('.bls__wishlist-no-product-js');
                if (wishlist_items === null || wishlist_items.length === 0) {
                    _this.skeletonFunction(0);
                    div_no_product.classList.remove('d-none');
                } else {
                    // Track wishlist page view
                    trackWishlistView(wishlist_items);

                    var query = '';
                    wishlist_items.forEach((e, key, wishlist_items) => {
                        if (!Object.is(wishlist_items.length - 1, key)) {
                            query += e + '%20OR%20handle:';
                        } else {
                            query += e;
                        }
                    });

                    var productAjaxURL = "?view=wishlist&type=product&options[unavailable_products]=last&q=handle:" + query;

                    fetch(`${window.routes.search_url}${productAjaxURL}`)
                        .then(response => response.text())
                        .then((responseText) => {
                            const html = parser.parseFromString(responseText, 'text/html');
                            const exist_row = wishlistDiv.querySelector('.row');
                            if (exist_row) exist_row.remove();

                            const er = html.querySelector(".bls__wishlist-page-main > .row");
                            if (wishlist_items.length !== 0 && er) {
                                wishlistDiv.innerHTML = html.querySelector(".bls__wishlist-page-main").innerHTML;
                                _this.skeletonFunction(700);

                                // 🔥 Attach remove button listeners after DOM is updated
                                _this.attachRemoveListeners();
                            } else {
                                _this.skeletonFunction(0);
                                div_no_product.classList.remove('d-none');
                            }
                            _this.mergeItems();
                        })
                        .catch((e) => {
                            console.error(e);
                        })
                        .finally(e => {
                            BlsColorSwatchesShopify.init();
                            BlsSubActionProduct.handleInitQuickviewAction();
                            BlsSubActionProduct.init();
                            BlsLazyloadImg.init();
                        });
                }
            }
        },

        // 🔥 Attach click listeners to wishlist remove buttons
        attachRemoveListeners: function () {
            wishlistDiv.querySelectorAll('[data-wishlist-remove], .bls__wishlist-remove, .bls__remove-wishlist').forEach(btn => {
                btn.addEventListener('click', function () {
                    const productItem = btn.closest('[data-product-handle]');
                    const handle = productItem?.dataset.productHandle;
                    if (handle) {
                        trackWishlistEvent('remove_from_wishlist', handle);
                    }
                });
            });
        },

        mergeItems: function () {
            const arr = [];
            if (wishlistDiv) {
                wishlistDiv.querySelectorAll(".bls__product-item").forEach(e => {
                    arr.push(e?.dataset.productHandle);
                });
            }
            localStorage.setItem('bls__wishlist-items', JSON.stringify(arr));
        },

        skeletonFunction: function (timer) {
            window.setTimeout(function () {
                if (this.document.querySelector('skeleton-page')) {
                    this.document.querySelector('skeleton-page').remove();
                }
                if (this.document.querySelector('.bls__wishlist-page-section-inner')) {
                    this.document.querySelector('.bls__wishlist-page-section-inner').classList.remove('d-none');
                }
            }, timer);
        }
    };
})();

BlsWishlistPageShopify.initWishlistItems();